var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageFooter',{staticClass:"landing-page-footer",attrs:{"enable-lang-selector":false,"feedback-widget-faq-url":null,"help":null,"more-info":_vm.moreInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }